module.exports = __webpack_public_path__ + "img/073.b5de8f93.jpeg";